import React, { useEffect, useState } from "react";
import { supabase } from "../utils/supabaseClient";
import "../styles/Partnerships.css";

const Partnerships = () => {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const { data, error } = await supabase
          .from("partners")
          .select("*")
          .order("name");

        if (error) {
          throw error;
        }

        setPartners(data);
      } catch (err) {
        setError("Failed to load partners data");
        console.error("Error fetching partners:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPartners();
  }, []);

  if (loading) {
    return (
      <section className="partnerships-section">
        <div className="loading">Loading partnerships...</div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="partnerships-section">
        <div className="error">{error}</div>
      </section>
    );
  }

  return (
    <section className="partnerships-section">
      <h2 className="partnerships-title">Our Strategic Partnerships</h2>
      <p className="partnerships-intro">
        We are proud to be partnered with industry leaders, enabling us to
        deliver world-class solutions:
      </p>
      <div className="partnerships-list">
        {partners.map((partner) => (
          <div key={partner.id} className="partnership-item">
            <img
              src={partner.icon_url}
              alt={`${partner.name} logo`}
              className="partnerships-logo"
            />
            <div className="partner-content">
              <h3 className="partner-name">{partner.name}</h3>
              <p className="partner-description">{partner.description}</p>
              {partner.url && (
                <a
                  href={partner.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="partnerships-external-link"
                >
                  Learn More
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Partnerships;
